interface LoadScriptArgs {
  src: string;
  onload: () => void;
  id?: string;
  async?: boolean
  dataDocumentLanguage?: boolean
}

export const loadScript = (args: LoadScriptArgs): void => {
  const { src, onload, id, dataDocumentLanguage} = args;
  const script = document.createElement("script");
  script.type="text/javascript"
  if(dataDocumentLanguage) script.setAttribute("data-document-language", "true");
  if(args.async) script.async = true;
  if(id) script.setAttribute("data-domain-script", id);
  script.src = src;
  script.onload = onload;
  script.onerror = () => console.warn(`[ScriptsLoader] Failed to load script: ${src}`);
  document.head.appendChild(script);
};
